import { render } from "./IconInCircle.vue?vue&type=template&id=000b6b9a&scoped=true"
import script from "./IconInCircle.vue?vue&type=script&lang=js"
export * from "./IconInCircle.vue?vue&type=script&lang=js"

import "./IconInCircle.vue?vue&type=style&index=0&id=000b6b9a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000b6b9a"]])

export default __exports__